import { render, staticRenderFns } from "./postdoctorPatent.vue?vue&type=template&id=02364207&scoped=true&"
import script from "./postdoctorPatent.vue?vue&type=script&lang=js&"
export * from "./postdoctorPatent.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorPatent.vue?vue&type=style&index=0&id=02364207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02364207",
  null
  
)

export default component.exports